import { createSlice } from '@reduxjs/toolkit';

export const categoriaCotizacionSlice = createSlice({
  name: 'categoriaCotizacion',
  initialState: {
    categoriaCotizacionesList: [],
  },
  reducers: {
    setCategoriaCotizacionesRedux: (state, { payload }) => {
      state.categoriaCotizacionesList = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setCategoriaCotizacionesRedux } = categoriaCotizacionSlice.actions;
